"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarDropdown = void 0;

var _react = _interopRequireWildcard(require("react"));

var _molecules = require("../../molecules");

var _ = require("../..");

var _DashboardPanel = require("../DashboardPanel");

var _RelationsList = require("../RelationsList");

var _helpers = require("../../util/helpers");

require("./AvatarDropdown.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Avatar Dropdown
var AvatarDropdown = function AvatarDropdown(_ref) {
  var user = _ref.user,
      version = _ref.version,
      relations = _ref.relations,
      traceIdURL = _ref.traceIdURL,
      offsetAxisX = _ref.offsetAxisX,
      offsetAxisY = _ref.offsetAxisY,
      maxHeight = _ref.maxHeight,
      utm_source = _ref.utm_source,
      utm_medium = _ref.utm_medium,
      utm_campaign = _ref.utm_campaign,
      handleLogOut = _ref.handleLogOut;
  var userImageUrl = user ? "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(user.user_id, "&version=").concat(version) : null;
  var userInitials = user ? (0, _helpers.getInitials)(user.first_name, user.last_name) : null;
  var referLink = "https://traceup.com/refer?utm_source=".concat(utm_source, "&utm_medium=").concat(utm_medium, "&utm_campaign=").concat(utm_campaign);
  return /*#__PURE__*/_react.default.createElement(_.DropdownMenu, {
    title: "Avatar",
    menuPortal: "#modal-root",
    className: "AvatarDropdown",
    classNameMenu: "dropdown",
    menuDirection: "bottom",
    offsetAxisX: offsetAxisX,
    offsetAxisY: offsetAxisY,
    button: /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
      trkAction: "Avatar Pressed",
      imageUrl: userImageUrl,
      initials: userInitials
    })
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "avatardropdown-inner-content",
    style: {
      maxHeight: maxHeight
    }
  }, /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
    classNames: "family",
    title: "My family"
  }, /*#__PURE__*/_react.default.createElement(_RelationsList.RelationsList, {
    user: user,
    baseURL: traceIdURL,
    relations: relations
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/_react.default.createElement(_DashboardPanel.DashboardPanel, {
    title: "More"
  }, /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    trkAction: "Academy Pressed",
    icon: _.Icon.Type.Academy,
    href: "https://traceup.com/soccer/academy",
    title: "Academy"
  }), /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    trkAction: "Refer a Team Pressed",
    icon: _.Icon.Type.Referral,
    href: referLink,
    title: "Refer a team. Get $100"
  }), /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    trkAction: "Help Pressed",
    icon: _.Icon.Type.Question,
    href: "https://traceup.com/soccer/help",
    title: "Help"
  }), /*#__PURE__*/_react.default.createElement(_molecules.DashboardPanelLink, {
    trkAction: "Sign Out Pressed",
    handleClick: function handleClick(e) {
      return handleLogOut();
    },
    icon: _.Icon.Type.SignOut,
    title: "Sign out"
  }))));
};

exports.AvatarDropdown = AvatarDropdown;
AvatarDropdown.defaultProps = {
  maxHeight: 'none',
  utm_source: 'go',
  utm_medium: 'webapp',
  utm_campaign: 'refs'
};